<div class="model-heading-section mb-16">
    <div>
        <h2 class="m-0 mb-8 font-size-22">Model Configuration</h2>
    </div>
    <div>
        <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Add Model'"
            [iconSrc]="'/assets/icons/Plus_button.svg'" (click)="addUpdateModel()"></app-button>
    </div>
</div>
<div class="model-mgmt-card">
    <mat-card class="p-24">
        <div class="d-flex justify-content-between align-items-center mb-16">
            <h3 class="m-0">Configured Models ({{activeModels.length + inactiveModels.length}})</h3>
            
            <div class="position-relative search-input-box">
                <input type="text" placeholder="Search" [(ngModel)]="searchData" (ngModelChange)="onValueChange()" #searchInput class="p-8 search-input" style="width: 94%; font-size: 14px;">
                <div class="position-absolute search-icon cursor-pointer">
                    <div class="d-flex align-items-center" style="gap: 8px;">
                        <img src="/assets/admin-images/search_cancel_icon.png" style="height: 20px;" alt="search" (click)="clearSearch()" *ngIf="searchData?.length">
                        <span style="color: #E1E1EA;" *ngIf="searchData?.length">|</span>
                        <img src="/assets/icons/Group 57082.svg" alt="search" (click)="onSearch(searchInput.value)">
                    </div>
                </div>
            </div>
        </div>
        <mat-tab-group animationDuration="0ms">
            <mat-tab label="Active ({{activeModels.length}})" class="mb-8 font-size-16 font-weight-700">
                <div *ngIf="activeModels.length">
                    <div class="mt-16" *ngFor="let model of activeModels; let i = index">
                        <div class="d-flex justify-content-between align-items-center model-container">
                            <div>
                                <h4 class="m-0 mb-6">{{model?.name}}</h4>
                                <p class="m-0 font-size-14 sub-text"><span>{{model?.cloud_model}}</span><span class="vr">|</span> <span>{{model?.value}}</span></p>
                            </div>
                            <div class="d-flex align-items-center">
                                <div>
                                    <img src="/assets/admin-images/pen_icon.png" alt="edit" class="mr-16 cursor-pointer" style="height: 24px;" (click)="updateModel(model)"/>
                                </div>
                                <div>
                                    <mat-slide-toggle 
                                        (change)="aciveInactiveModel(model,$event)"
                                        class="example-margin"
                                        [checked]="model.is_active">
                                    </mat-slide-toggle>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin: 30px; font-size: 24px; font-weight: 700; text-align: center;" *ngIf="!activeModels.length">No results found</div>
            </mat-tab>
            <mat-tab label="Inactive ({{inactiveModels.length}})" class="mb-8 font-size-16 font-weight-700">
                <div *ngIf="inactiveModels.length">
                    <div class="mt-16" *ngFor="let model of inactiveModels">
                        <div class="d-flex justify-content-between align-items-center model-container">
                            <div>
                                <h4 class="m-0 mb-6">{{model?.name}}</h4>
                                <p class="m-0 font-size-14 sub-text"><span>{{model?.cloud_model}}</span><span class="vr">|</span> <span>{{model?.value}}</span></p>
                            </div>
                            <div class="d-flex align-items-center">
                                <div>
                                    <img src="/assets/admin-images/pen_icon.png" alt="edit" class="mr-16 cursor-pointer" style="height: 24px;" (click)="updateModel(model)"/>
                                </div>
                                <div>
                                    <mat-slide-toggle (change)="aciveInactiveModel(model,$event)"
                                        class="example-margin"
                                        [checked]="model.is_active">
                                    </mat-slide-toggle>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin: 30px; font-size: 24px; font-weight: 700; text-align: center;" *ngIf="!inactiveModels.length">No results found</div>
            </mat-tab>
        </mat-tab-group>
    </mat-card>
</div>


@if(isLoading){
    <app-loader></app-loader>
}